import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import styled from 'styled-components';

export const AuditLogEventDetailsWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  flex: 0 0 50%;
  gap: 24px;
  width: 100%;

  ${media.tablet`
    flex: 0 0 100%;
  `}
`;
